<div class="container">
  <div class="row">
    <div class="col-md-4 col-md-offset-4">
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="text-center">
            <h3><img src="../../../assets/img/new_dasboard_imges/loginbluvbay.png"/></h3>
            <p>Create your new password</p>
            <div class="panel-body">
              <form autocomplete="off" [formGroup]="resetPasswordForm" (ngSubmit)="createPassword()">
                <div class="form-group">
                  <input type="text" name="username" [(ngModel)]="userDetails.userName" required
                         placeholder="Enter mobile number" class="form-control" formControlName="usernumber"
                         [ngClass]="{ 'is-invalid': submitted && f.usernumber.errors }">
                  <div *ngIf="submitted && f.usernumber.errors" class="invalid-feedback">
                    <div *ngIf="f.usernumber.errors.required" class="alert-color">Mobile number is required.</div>
                  </div>
                </div>
                <div class="form-group">
                  <input type="password" name="password" [(ngModel)]="userDetails.password" required
                         placeholder="Create Password" class="form-control" formControlName="password"
                         [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                  <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required" class="alert-color">Password is required.</div>
                    <div *ngIf="f.password.errors.minlength" class="alert-color">Minimum 6 characters.</div>
                    <div *ngIf="f.password.errors.maxlength" class="alert-color">Maximum 10 characters.</div>
                  </div>
                </div>
                <div class="form-group">
                  <input type="password" name="confirmpassword" [(ngModel)]="userDetails.confirm_password" required
                         placeholder="Confirm Password" class="form-control" formControlName="confirmpassword"
                         [ngClass]="{ 'is-invalid': submitted && f.confirmpassword.errors }">
                  <div *ngIf="submitted && f.confirmpassword.errors" class="invalid-feedback">
                    <div *ngIf="f.confirmpassword.errors.required" class="alert-color">Confirm Password is required.</div>
                  </div>
                </div>
                <div class="form-group">
                  <button class="update">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
